import styled from "styled-components/macro";

export const Container = styled.div`
  position: fixed;
  /* top: 50%;
  left: 50%;

  transform: translateX(-50%) translateY(-50%); */
  border-radius: 20px;
  background: var(--menu-color-fullscreen);
  box-shadow: var(--default-drop-shadow);
  padding: 32px;
  transition: top 150ms ease-out;

  width: 500px;

  color: var(--grey-0);
  z-index: 40000;
  line-height: 1.5em;
  font-weight: 500;

  p {
    margin-bottom: 1.5rem;
  }

  ul {
    list-style-type: disc;
    li {
      margin-left: 25px;
      list-style-type: disc;
    }
  }

  a {
    position: absolute;
    top: 15px;
    right: 15px;
    color: var(--grey-1);
    font-size: 12px;
  }

  dl {
    section {
      display: flex;
      margin-bottom: 10px;
      dt {
        width: 175px;
        span {
          float: right;
          background: var(--grey-3);
          padding: 3px 6px;
          margin-right: 5px;
          border-radius: 3px;
          color: var(--grey-1);
          font-size: 13px;
          position: relative;
          top: 2px;
        }
      }

      dd {
        padding: 3px 6px;
      }
    }
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--grey-0);
  opacity: 0.5;
  z-index: 1;
`;
